import React, {useState} from 'react'
import { Row, Col, Modal, Accordion, Card, Button } from 'react-bootstrap'
import { useSelector, useDispatch } from 'react-redux'
import { sendErrorNotification } from '../../../universal/notifications/notifications'
import { ToastContainer } from 'react-toastify'
import NumberFormat from 'react-number-format'

import { changeDeliveriesModal, requestAddDelivery } from '../../../../redux/actions/deliveries'
import { TransparentButton, SolidButton } from '../../../library/button'
import { auth } from '../../../../networking/firebase'

import './style.scss'
import { Input } from '../../../library/input'
import { Textarea } from '../../../library/textarea'

const Index = () => {

	const dispatch = useDispatch()

	const modalState = useSelector(state => state.deliveries.showModals.newModal)

	const addLoading = useSelector(state => state.deliveries.addDelivery.loading)
	const companyId = useSelector(state => state.activeCompany.activeCompany.id)

	const [deliveryObject, setDeliveryObject] = useState({
		addedBy: auth.currentUser.uid,
		general:{
			client: null,
			title: null,
			description: null,
			amount: null,
			progress: 0
		},
		duration: {
			start: null,
			end: null,
		},
		contact: {
			email: null
		},
		security:{
			passwordOne: null,
			passwordTwo: null
		}
	})

    const handleClose = () => {
		dispatch(changeDeliveriesModal({newModal: false}))
	}

	const clickAddNewDelivery = () => {
		if(deliveryObject.general.client && deliveryObject.general.title && deliveryObject.general.amount){
			dispatch(requestAddDelivery({delivery: deliveryObject, companyId: companyId}))
		} else {
			sendErrorNotification("Du må fulle inn kunde, tittel og beløp før du kan legge til en levering.")
		}
	}

    return(
		<div>
			<ToastContainer/>
			<Modal className="add-delivery-modal" show={modalState} onHide={() => handleClose()}>
				<Modal.Header>
					<h5 className="modal-title" id="addModalTitle">Legg til ny leveranse</h5>
					<button onClick={() => handleClose()} className="close-button"><i class="fad fa-times"></i></button>
				</Modal.Header>
				<Modal.Body>
					<p className="modal-description">Fyll inn allt felt i skjemaet under for å legge til en ny leveranse på en av kundene dine.</p>
					<div className="modal-content-container">
					<Accordion className="delivery-accordion" defaultActiveKey="0">
						<Card className="single-card top">
							<Card.Header className="card-header">
								<Accordion.Toggle className="card-toggle" as={Button} variant="link" eventKey="0">
									Generelt <i class="fad fa-chevron-down"></i>
								</Accordion.Toggle>
							</Card.Header>
							<Accordion.Collapse eventKey="0">
								<Card.Body className="card-body">
									<Row className="info-row">
										<Col className="info-col">
											<label>Kunde *</label>
											<Input value={deliveryObject.general && deliveryObject.general.client ? deliveryObject.general.client:null} onChange={(e) => setDeliveryObject({...deliveryObject, general: {...deliveryObject.general, client: e.target.value}})} placeholder="Kunde" type="text"/>
										</Col>
									</Row>
									<Row className="info-row">
										<Col className="info-col">
											<label>Tittel *</label>
											<Input value={deliveryObject.general && deliveryObject.general.title ? deliveryObject.general.title:null} onChange={(e) => setDeliveryObject({...deliveryObject, general: {...deliveryObject.general, title: e.target.value}})} placeholder="Tittel" type="text"/>
										</Col>
									</Row>
									<Row className="info-row">
										<Col className="info-col">
											<label>Beskrivelse</label>
											<Textarea value={deliveryObject.general && deliveryObject.general.description ? deliveryObject.general.description:null} onChange={(e) => setDeliveryObject({...deliveryObject, general: {...deliveryObject.general, description: e.target.value}})} rows={3} placeholder="Beskrivelse av produktet du selger." />
										</Col>
									</Row>
									<Row className="info-row">
										<Col className="info-col">
											<label>Beløp *</label>
											<Input format="amount" value={deliveryObject.general && deliveryObject.general.amount ? deliveryObject.general.amount:null} onChange={(e) => setDeliveryObject({...deliveryObject, general: {...deliveryObject.general, amount: e.target.value}})} placeholder="10 000" type="text"/>
										</Col>
									</Row>
								</Card.Body>
							</Accordion.Collapse>
						</Card>
						<Card className="single-card">
							<Card.Header className="card-header">
								<Accordion.Toggle className="card-toggle" as={Button} variant="link" eventKey="1">
									Tidsperiode <i class="fad fa-chevron-down"></i>
								</Accordion.Toggle>
							</Card.Header>
							<Accordion.Collapse eventKey="1">
								<Card.Body className="card-body">
									<Row className="info-row">
										<Col className="info-col">
											<label>Startdato</label>
											<Input value={deliveryObject.duration && deliveryObject.duration.start ? deliveryObject.duration.start:null} onChange={(e) => setDeliveryObject({...deliveryObject, duration: {...deliveryObject.duration, start: e.target.value}})} placeholder="Start" type="date"/>
										</Col>
									</Row>
									<Row className="info-row">
										<Col className="info-col">
											<label>Leveringsdato</label>
											<Input value={deliveryObject.duration && deliveryObject.duration.end ? deliveryObject.duration.end:null} onChange={(e) => setDeliveryObject({...deliveryObject, duration: {...deliveryObject.duration, end: e.target.value}})} placeholder="Slutt" type="date"/>
										</Col>
									</Row>
								</Card.Body>
							</Accordion.Collapse>
						</Card>
						<Card className="single-card">
							<Card.Header className="card-header">
								<Accordion.Toggle className="card-toggle" as={Button} variant="link" eventKey="2">
									E-postoppdatering <i class="fad fa-chevron-down"></i>
								</Accordion.Toggle>
							</Card.Header>
							<Accordion.Collapse eventKey="2">
								<Card.Body className="card-body">
									<p className="card-information">Legg til en mottaker du vil at skal få en automatisk oppdatering på alle oppdateringer du gjør underveis i leveransen. Dette er ikke påkrevd.</p>
									<Row className="info-row">
										<Col className="info-col">
											<label>E-postadresse</label>
											<Input value={deliveryObject.contact && deliveryObject.contact.email ? deliveryObject.contact.email:null} onChange={(e) => setDeliveryObject({...deliveryObject, contact: {...deliveryObject.contact, email: e.target.value}})} placeholder="E-postadresse" type="email"/>
										</Col>
									</Row>
								</Card.Body>
							</Accordion.Collapse>
						</Card>
						<Card className="single-card">
							<Card.Header className="card-header">
								<Accordion.Toggle className="card-toggle" as={Button} variant="link" eventKey="3">
									Passordbeskyttelse <i class="fad fa-chevron-down"></i>
								</Accordion.Toggle>
							</Card.Header>
							<Accordion.Collapse eventKey="3">
								<Card.Body className="card-body">
									<p className="card-information">Passordbeskyttelse på leveransen er frivillig, men dersom du ikke skulle benytte deg av det vil alle med link kunne se detaljene rundt leveringen din.</p>
									<Row className="info-row">
										<Col className="info-col">
											<label>Passord</label>
											<Input value={deliveryObject.security && deliveryObject.security.passwordOne ? deliveryObject.security.passwordOne:null} onChange={(e) => setDeliveryObject({...deliveryObject, security: {...deliveryObject.security, passwordOne: e.target.value}})} type="password" placeholder="Passord"/>
										</Col>
									</Row>
									<Row className="info-row">
										<Col className="info-col">
											<label>Passord igjen</label>
											<Input value={deliveryObject.security && deliveryObject.security.passwordTwo ? deliveryObject.security.passwordTwo:null} onChange={(e) => setDeliveryObject({...deliveryObject, security: {...deliveryObject.security, passwordTwo: e.target.value}})} type="password" placeholder="Passord"/>
										</Col>
									</Row>
								</Card.Body>
							</Accordion.Collapse>
						</Card>
					</Accordion>
				</div>
				</Modal.Body>
				<Modal.Footer>
					<TransparentButton title="Avbryt" id="closeButtonAdd" type="button" data-dismiss="modal" onClick={() => handleClose()} />
                	<SolidButton onClick={() => clickAddNewDelivery()} title={addLoading ? "Legger til..":"Legg til"} icon={addLoading ? <i className="fas fa-circle-notch fa-spin"></i>:<i className="fas fa-plus"></i>} type="button"/>
				</Modal.Footer>
			</Modal>
		</div>
    )
}

export default Index



